export const get = function(obj, key, empty) {
    return key.split(".").reduce(function(o, x) {
        return (typeof o == "undefined" || o === null) ? o : o[x]
    }, obj) || ( isEmpty(empty) ? null : empty )
}

export const set = function(obj, key, value) {
    if (!isEmpty(value)) {
        obj[key] = value
    }
}

export const isEmpty = function(val) {
    return (typeof val == "undefined" || val == null || val.length <= 0) ? true : false;
}

export const has = function(obj, key) {
    return key.split(".").every(function(x) {
        if (typeof obj != "object" || obj === null || !(x in obj))
            return false
        obj = obj[x]
        return true;
    })
}

export const contains = function(objs, eqlFunc) {
    for (let value of objs) {
        if (eqlFunc(value)) {
            return true
        }
    }
    return false
}

export const indexOf = function(objs, func) {
    for (let i in objs) {
        if (func(objs[i])) {
            return i
        }
    }
    return null
}

export const isPojo = function(obj) {
    return typeof obj === 'object'
        && obj !== null
        && obj.constructor == Object
}

export const split = function(str, char, func) {
    if (isEmpty(str)) return []
    func = func || ((val) => val)
    let objs = str.split(char)
    for (let i in objs) {
        objs[i] = func(objs[i])
    }
    return objs
}

export const pluck = function(obj, keys) {
    if (keys == null) return {}
    return keys.reduce( (newObj, key) => (newObj[key] = obj[key], newObj), {})
}

export const prune = function(obj, func) {
    func = func || isEmpty
    for (const key in obj) {
        if (func(obj[key]))
            delete obj[key]
    }
    return obj
}

export const first = function(array) {
    return !isEmpty(array) ? (array.length > 0 ? array[0] : null) : null
}

export const last = function(array) {
    return !isEmpty(array) ? array[array.length-1] : null
}

export const comb = function() {
    let str = ''
    for (var argument of arguments) {
        if (argument) {
            str += argument + ' '
        }
    }
    return str
}

export const phoneFormat = function(phone) {
    if (!phone) return ''
    phone = String(phone)
    return phone.substring(phone.indexOf("(") + 1)
        .replace(/[^0-9]/g, '')
        .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
}

export const apaFormat = function(apa) {
    if (apa == null) return '-'
    return apa.toFixed(1)
}

export const nameFormat = function(obj) {
    let parts = []
    if (obj.first_name) parts.push(obj.first_name)
    if (obj.last_name) parts.push(obj.last_name)
    return parts.join(' ')
}

export const daysOfTheWeek = function(course) {
    var items = []
    if (!course) return ''
    if (course.meet_sun || course.meetSun) items.push('Su')
    if (course.meet_mon || course.meetMon) items.push('M')
    if (course.meet_tue || course.meetTue) items.push('Tu')
    if (course.meet_wed || course.meetWed) items.push('W')
    if (course.meet_thu || course.meetThu) items.push('Th')
    if (course.meet_fri || course.meetFri) items.push('F')
    if (course.meet_sat || course.meetSat) items.push('Sa')
    return items.join(' ')
}

export const isMobileScreenSize = function() {
    return document.documentElement.clientWidth <= 480
}

export const isMobile = function() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

function normalizeNamespace (fn) {
    return (namespace, map) => {
        if (typeof namespace !== 'string') {
            map = namespace
            namespace = ''
        }
        else if (namespace.charAt(namespace.length - 1) !== '/') {
            namespace += '/'
        }
        return fn(namespace, map)
    }
}

export const cloneState = normalizeNamespace((namespace, states) => {

    function normalizeMap (map) {
        return Array.isArray(map)
            ? map.map(key => ({ key, val: key }))
            : Object.keys(map).map(key => ({ key, val: map[key] }))
    }

    const res = {}
    normalizeMap(states).forEach(({ key, val }) => {
        res[key] = function mappedState () {
            let state = this.$store.state
            let getters = this.$store.getters
            if (namespace) {
                const module = this.$store._modulesNamespaceMap[namespace]
                if (!module) return

                state = module.context.state
                getters = module.context.getters
            }
            const value = typeof val === 'function'
                ? val.call(this, state, getters)
                : state[val]
            return JSON.parse(JSON.stringify(value))
            // return Object.assign({}, value)
        }
    })
    return res
})


export const debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result
    if (null == wait) wait = 100

    function later() {
        var last = Date.now() - timestamp

        if (last < wait && last >= 0) {
            timeout = setTimeout(later, wait - last)
        }
        else {
            timeout = null
            if (!immediate) {
                result = func.apply(context, args)
                context = args = null
            }
        }
    }

    var debounced = function() {
        context = this
        args = arguments
        timestamp = Date.now()
        var callNow = immediate && !timeout
        if (!timeout) timeout = setTimeout(later, wait)
        if (callNow) {
            result = func.apply(context, args)
            context = args = null
        }
        return result
    }

    debounced.clear = function() {
        if (timeout) {
            clearTimeout(timeout)
            timeout = null
        }
    }

    debounced.flush = function() {
        if (timeout) {
            result = func.apply(context, args)
            context = args = null

            clearTimeout(timeout)
            timeout = null
        }
    }

    return debounced
}
